import React, { useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useForm from 'react-hook-form';
import PropTypes from 'prop-types';
/* actions */
import { addVeterinarians } from '../../redux/actions/veterinarians';
/* components */
import ErrorMsgField from '../../components/ErrorMsgField';
import AlertMsg from '../../components/AlertMsg';
import FormFooter from '../../components/FormFooter';
import FormHeader from '../../components/FormHeader';
/* form-validation */
import schema from '../../form-validation/veterinarian';
/* utils */
import handleChangeDefault from '../../utils/handleChangeDefault';
import statesBR from '../../utils/statesBR';

function Add (props) {
  const { handleModalClose } = props;
  const dispatch = useDispatch();
  const submitButton = useRef();
  const { register, handleSubmit, errors, reset } = useForm({
    validationSchema: schema,
    reValidateMode: 'onSubmit'
  });
  const sessionUser = useSelector(state => state.authentications.user);
  const company = sessionUser.company._id;
  const veterinarians = useSelector(state => state.veterinarians);
  const INITIAL_VALUES = {
    name: '',
    additionalInformation: '',
    crmvNumber: '',
    crmvUF: '',
    company
  };
  const [data, setData] = useState(INITIAL_VALUES);

  const submit = () => {
    const resetForm = () => {
      reset();
      setData({ ...INITIAL_VALUES });
    };
    const newData = {
      ...data,
      crmv: {
        number: data.crmvNumber,
        uf: data.crmvUF
      }
    };
    delete newData.crmvNumber;
    delete newData.crmvUF;
    dispatch(addVeterinarians(newData, resetForm, submitButton.current));
  };

  return (
    <div className="container-fluid">
      {veterinarians.addSuccess && (
        <AlertMsg type="success" msg="Veterinário cadastrado com sucesso" />
      )}
      {veterinarians.errorContent &&
        !veterinarians.errorContent.message.includes('400') &&
        veterinarians.addError && (
        <AlertMsg type="danger" msg="Falha durante cadastro do veterinário" />
      )}
      {veterinarians.errorContent &&
        veterinarians.errorContent.message.includes('400') &&
        veterinarians.addError && (
        <AlertMsg
          type="danger"
          msg="Um veterinário com o CRMV informado já está cadastrado"
        />
      )}
      {!veterinarians.addSuccess && !veterinarians.addError && (
        <AlertMsg type="info" msg="Área cadastro de veterinários" />
      )}
      <FormHeader title="Cadastrar Veterinário" />
      <a
        className="btn btn-info"
        href="https://siscad.cfmv.gov.br/paginas/busca"
        target="_blank"
        rel="noopener noreferrer"
      >
        Consultar CRMV
      </a>
      <form onSubmit={handleSubmit(submit)}>
        <div className="row">
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="name">
                Nome<span className="field-required">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id="name"
                name="name"
                autoComplete="off"
                value={data.name}
                onChange={evt => handleChangeDefault(evt, data, setData)}
                ref={register}
              />
              {errors.name && errors.name.type === 'required' && (
                <ErrorMsgField type="required" />
              )}
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group">
              <label htmlFor="crmvNumber">
                N&deg; CRMV<span className="field-required">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id="crmvNumber"
                name="crmvNumber"
                number="on"
                autoComplete="off"
                value={data.crmvNumber}
                onChange={evt => handleChangeDefault(evt, data, setData)}
                ref={register}
              />
              {errors.crmvNumber && errors.crmvNumber.type === 'required' && (
                <ErrorMsgField type="required" />
              )}
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group">
              <label htmlFor="crmvUF">
                UF CRMV<span className="field-required">*</span>
              </label>
              <select
                className="form-control"
                id="crmvUF"
                name="crmvUF"
                value={data.crmvUF}
                onChange={evt => handleChangeDefault(evt, data, setData)}
                ref={register}
              >
                <option value="">-- Selecione --</option>
                {Object.keys(statesBR).map((state, i) => {
                  return (
                    <option key={i} value={state}>
                      {statesBR[state]} - {state}
                    </option>
                  );
                })}
              </select>
              {errors.crmvUF && errors.crmvUF.type === 'required' && (
                <ErrorMsgField type="required" />
              )}
            </div>
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="additionalInformation">Informações Adicionais</label>
          <textarea
            className="form-control"
            id="additionalInformation"
            name="additionalInformation"
            rows="3"
            value={data.additionalInformation}
            onChange={evt => handleChangeDefault(evt, data, setData)}
            ref={register}
          ></textarea>
        </div>
        {handleModalClose ? (
          <div className="container-fluid p-0">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleModalClose}
            >
              <i className="fa fa-times"></i>
              &nbsp;Fechar
            </button>
            <button
              type="submit"
              ref={submitButton}
              className="btn btn-primary float-right"
            >
              <i className="fa fa-save"></i>
              &nbsp;Salvar
            </button>
          </div>
        ) : (
          <FormFooter url="/veterinarians" reference={submitButton} />
        )}
      </form>
    </div>
  );
}

Add.propTypes = {
  handleModalClose: PropTypes.func
};

export default Add;
